"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

var _List = _interopRequireDefault(require("../List"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var _default = function _default(_ref) {
  var classes = _ref.classes,
      orderBy = _ref.orderBy,
      order = _ref.order,
      fields = _ref.fields,
      onHeaderCellClick = _ref.onHeaderCellClick,
      forceMore = _ref.forceMore,
      dataListParams = _ref.dataListParams,
      onLoadMoreClick = _ref.onLoadMoreClick,
      onLoading = _ref.onLoading,
      onLoaded = _ref.onLoaded,
      loading = _ref.loading,
      loaded = _ref.loaded;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.root
  }, /*#__PURE__*/_react["default"].createElement(_core.Table, {
    size: "small",
    className: classes.table
  }, /*#__PURE__*/_react["default"].createElement(_core.TableHead, null, /*#__PURE__*/_react["default"].createElement(_core.TableRow, null, Object.entries(fields).map(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
        label = _ref3[0],
        field = _ref3[1];

    return /*#__PURE__*/_react["default"].createElement(_core.TableCell, {
      className: classes.tableCellNoWrap,
      key: label,
      sortDirection: orderBy === label ? order : false
    }, !field.sort ? !!field.hideLabel ? "" : label : /*#__PURE__*/_react["default"].createElement(_core.TableSortLabel, {
      active: orderBy === label,
      direction: order,
      onClick: function onClick() {
        return onHeaderCellClick(label);
      }
    }, !!field.hideLabel ? "" : label));
  }))), /*#__PURE__*/_react["default"].createElement(_core.TableBody, null, /*#__PURE__*/_react["default"].createElement(_List["default"], _extends({}, dataListParams, {
    forceMore: forceMore,
    usedButton: true,
    onLoaded: onLoaded,
    onLoading: onLoading
  })))), !!loaded && !!(dataListParams === null || dataListParams === void 0 ? void 0 : dataListParams.useButton) && /*#__PURE__*/_react["default"].createElement(_core.Button, {
    fullWidth: true,
    variant: "contained",
    size: "large",
    color: "secondary",
    onClick: onLoadMoreClick,
    disabled: !!loading
  }, !!loading ? "Loading..." : "Load More"));
};

exports["default"] = _default;